<template>
    <div class="estate-card">
        <a href="#">       
            <img class="estate-carousel-image skeleton" src="/img/estate-placeholder-skeleton.png" height="400">
            <div class="estate-card-box-data">
                <div class="estate-card-price">
                    <div class="estate-card-current-price"></div>

                </div>

                <h3 class="estate-card-title"></h3>

                <h4 class="estate-card-subtitle"></h4>
            </div>
        </a>
    </div>
</template>

<script>
export default {

}
</script>